export const FlagIcon = ({ src, alt }: { src: string; alt: string }) => (
  <img src={src} alt={alt} width={16} height={10} />
);
